import { render } from "./QuoteSection.vue?vue&type=template&id=4ad93338"
import script from "./QuoteSection.vue?vue&type=script&lang=js"
export * from "./QuoteSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__